module.exports = __webpack_public_path__ + "img/45ne.52de1488.svg";